export const DeactivateCardValue = {
  CustomerRequest: "Customer Request",
  FraudRelatedConcern: "Fraud Related Concern",
  Others: "Others",
};

export default DeactivateCardValue;
